var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ShippingHeaderList',{attrs:{"title":_vm.$t('cadastro-transportadora'),"total":_vm.total,"pagination":true},on:{"fetch":_vm.pagination,"search":_vm.search}}),_c('el-card',[_c('ShippingHeaderSearch',{attrs:{"redirect":"shipping.add"},on:{"fetch":_vm.search}}),_c('ShippingTable',{attrs:{"tableData":_vm.tableData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }